import { type AxiosResponse } from 'axios'
import type { AxiosOptions } from 'shared/api'
import { baseApi } from 'entities/Auth'
import { BaseAnalyticsApi } from './baseAnalyticsApi'
import type {
  IPerformanceStatisticResponse,
  IPerformanceChartResponse,
  IPerformanceMemberParams,
  IPerformanceMembersResponse,
} from './types'

class PerformanceApi extends BaseAnalyticsApi<
  IPerformanceStatisticResponse,
  IPerformanceChartResponse
> {
  constructor() {
    super('performance')
  }

  getMembers = (
    params: IPerformanceMemberParams,
    options?: AxiosOptions
  ): Promise<AxiosResponse<IPerformanceMembersResponse>> => {
    return baseApi.get('analytics/analytics/performance/members', {
      params,
      ...options,
    })
  }
}

export const PerformanceAnalyticsApi = new PerformanceApi()
